import { faBars } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true'

interface UserDropdownProps {
  isMobile?: boolean
}

export const UserDropdown = ({ isMobile }: UserDropdownProps): React.ReactElement => {
  const menuClassNames: string[] = ['dropdown-menu']
  if (isMobile) {
    menuClassNames.push('dropdown-menu-end')
  }
  return (
    <div className="dropdown-toggle">
      <div className="avatar avatar-sm">
        <div className="py-4 rounded d-flex animate shadow-sm" />
      </div>
      {!isMobile && (
        <span className="d-inline-block animate my-3 ms-2 rounded" style={{ minWidth: '100px' }} />
      )}
    </div>
  )
}

export const SideNavSkeleton = (props: React.PropsWithChildren<{}>): React.ReactElement => {
  return (
    <nav
      className={
        `navbar navbar-vertical fixed-left navbar-expand-md shadow-sm bg-body-tertiary border-end border-body-secondary` +
        (isProduction ? '' : ' navbar-test')
      }
      id="sidebar"
    >
      <div className="container-fluid">
        <button type="button" className="navbar-toggler border-0 text-body">
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className="navbar-brand d-md-none w-25 my-1">
          <div
            className="navbar-brand-img animate mx-auto rounded"
            style={{ minHeight: '1.5rem' }}
          />
        </div>
        <div className="navbar-brand d-none d-md-block">
          <div className="py-4 rounded d-flex animate mx-auto mb-2 shadow-sm" />
          <p className="d-none d-md-block animate w-100 my-1 rounded" />
        </div>
        <div className="navbar-user d-md-none">
          <div className="dropdown">
            <UserDropdown isMobile={true} />
          </div>
        </div>
        <div className="collapse navbar-collapse" id="sidebarNavigation">
          <ul className="navbar-nav">
            {Array.from({ length: 7 })
              .fill(null)
              .map((_, i) => `nav-item-${i}`)
              .map(
                (key): React.ReactElement => (
                  <li className="nav-item" key={key}>
                    <div className="nav-link">
                      <span className="animate w-75 rounded" />
                    </div>
                  </li>
                ),
              )}
          </ul>
          <div className="mt-auto" />
          <div className="navbar-brand d-none d-md-block my-1">
            <div
              className="navbar-brand-img w-50 animate mx-auto mb-2 rounded"
              style={{ height: '2rem' }}
            />
            <div className="navbar-brand-img w-50 animate mx-auto rounded" />
          </div>
          <div className="navbar-user d-none d-md-flex" id="sidebarUser">
            <div className="dropup">
              <UserDropdown />
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export const MainContentSkeleton = (props: React.PropsWithChildren<{}>): React.ReactElement => {
  return (
    <div className="main-content skeleton">
      <div className="container-fluid py-2">{props.children}</div>
    </div>
  )
}

export const LayoutSkeleton = (props: React.PropsWithChildren<{}>): React.ReactElement => {
  return (
    <>
      <SideNavSkeleton />
      <MainContentSkeleton>{props.children}</MainContentSkeleton>
    </>
  )
}
